<template>
  <div class="slideshow">
    <transition name="fade">
      <div class="slide" :key="currentSlide">
        <component
          v-model="currentSlideData.data"
          :max="currentSlideData.max"
          :is="currentSlideData.type"/>
      </div>
    </transition>
  </div>
</template>

<script type="text/babel">
import PNRG from '../helpers/pnrg';
import ArticleList from './SlideshowTypes/ArticleList.vue';
import MachineList from './SlideshowTypes/MachineList.vue';

const pnrg = new PNRG(2);

export default {
  components: {
    ArticleList,
    MachineList,
  },
  data() {
    return {
      currentSlide: 0,
      direction: 1,
      transition: 750,
      autoplay: true,
      duration: 10000,
      $interval: null,
      random: true,
    };
  },
  mounted() {
    if (this.autoplay) this.startAutoplay();
  },
  methods: {
    startAutoplay() {
      // seed lastRandom with our currentValue
      pnrg.lastRandom = this.currentSlide;
      this.$interval = setInterval(() => {
        if (this.random) {
          this.setSlide(pnrg.next(this.slideCount));
        } else {
          this.nextSlide();
        }
      }, this.duration + this.transition);
    },
    stopAutoplay() {
      clearInterval(this.$interval);
    },
    setSlide(slide) {
      this.direction = Math.sign(slide - this.currentSlide);
      this.currentSlide = slide;
      if (this.autoplay) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.setSlide(this.currentSlide - 1);
      } else {
        this.setSlide(this.slideCount - 1);
      }
    },
    nextSlide() {
      if (this.currentSlide < this.slideCount - 1) {
        this.setSlide(this.currentSlide + 1);
      } else {
        this.setSlide(0);
      }
    },
  },
  computed: {
    currentSlideData() {
      return this.slides[this.currentSlide];
    },
    slideCount() {
      return (this.slides) ? this.slides.length : 0;
    },
    slides() {
      const slides = [
        {
          data: this.$store.getters.getOffers,
          type: 'ArticleList',
          multiSlide: false,
          max: 3,
        },
        {
          data: this.$store.getters.getNews,
          type: 'ArticleList',
          multiSlide: false,
          max: 3,
        },
        {
          data: this.$store.getters.getProducts,
          type: 'ArticleList',
          multiSlide: false,
          max: 3,
        },
        {
          data: this.$store.getters.getMachines,
          type: 'MachineList',
          multiSlide: false,
          max: 6,
        },
      ];

      return slides.filter((slide) => slide.data.length > 0);
    },
  },
};
</script>

<style lang="scss" scoped>
  .slide {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .fade-enter-active{
    transition: opacity 1.5s;
  }
  .fade-leave-active {
    opacity: 0;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
